var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuGridSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Menu Grid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9,34.9V48H48V34.9H34.9z M45.8,45.8h-8.7v-8.7h8.7V45.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9,17.5v13.1H48V17.5H34.9z M45.8,28.4h-8.7v-8.7h8.7V28.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9,0v13.1H48V0H34.9z M45.8,10.9h-8.7V2.2h8.7V10.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5,34.9V48h13.1V34.9H17.5z M28.4,45.8h-8.7v-8.7h8.7V45.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5,17.5v13.1h13.1V17.5H17.5z M28.4,28.4h-8.7v-8.7h8.7V28.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5,0v13.1h13.1V0H17.5z M28.4,10.9h-8.7V2.2h8.7V10.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0,34.9V48h13.1V34.9H0z M10.9,45.8H2.2v-8.7h8.7V45.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0,17.5v13.1h13.1V17.5H0z M10.9,28.4H2.2v-8.7h8.7V28.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0v13.1h13.1V0H0z M10.9,10.9H2.2V2.2h8.7V10.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuGridSquare);
export default __webpack_public_path__ + "static/media/menu-grid-square.50a9a5be6a4757c2426fa8e9d92a3503.svg";
export { ForwardRef as ReactComponent };